import { verifyConstants } from "../../constants";

const initialState = {
  dataList: {},
  isLoading: false,
  isFailure: false,
  isSent: false,
  isInbox: false,
  isListFailure: false
}

export default function verify(state = initialState, action) {
  switch (action.type) {
    /*********
     초기화
     **********/
    case verifyConstants.VERIFY_INIT:
      return {
        ...state,
        isLoading: false,
        isFailure: false,
        certificateInfo: null,
        isSent: false,
        isInbox: false,
        isListFailure: false,
        InboxList : null,
        SentList : null
      }

    /*********
     증명서 진본검증
     **********/
    case verifyConstants.VERIFY_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }

    case verifyConstants.VERIFY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        certificateInfo: action.response.data?.payload
      }

    case verifyConstants.VERIFY_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }

    case verifyConstants.VERIFY_LIST_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading
      }

    case verifyConstants.VERIFY_LIST_INBOX_SUCCESS:
      return {
        ...state,
        isInbox: true,
        isLoading: false,
        dataList: action.response.data?.payload
      }

    case verifyConstants.VERIFY_LIST_SENT_SUCCESS:
      return {
        ...state,
        isSent: true,
        isLoading: false,
        dataList: action.response.data?.payload
      }

    case verifyConstants.VERIFY_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        isListFailure : true
      }

    default:
      return state
  }
}